export default "__VITE_ASSET__Dd7KQXkp__"